import { useState } from "react";
import { Heading, TabRow } from "cai-fusion";

import AccessControl from "./adminSettings/accessControl";
import FactsControl from "./adminSettings/factsControl";
import ModelConfiguration from "./adminSettings/modelConfiguration";
import DataConnections from "./adminSettings/dataConnections";

import env from "../../../configs/envConfig";


const SymphonyAdminSettings = () => {

	const [currTab, setCurrTab] = useState("models");

	return (
		<div className="row">
			<div className="col-md-12">
				<Heading size={1}>{env.REACT_APP_BRANDING_SYMPHONY_NAME ?? "Maestro"} Settings</Heading>
				<TabRow 
					className="l-mt-sm"
					tabTitles={["Models", "Access Control", "Facts", "Integrations"]}
					tabIDs={["models", "licenses", "facts", "connections"]}
					activeTab={currTab}
					onTabChange={(tab) => setCurrTab(tab)}
				/>
				{currTab === "models" && <ModelConfiguration />}
				{currTab === "licenses" && <AccessControl />}
				{currTab === "facts" && <FactsControl />}
				{currTab === "connections" && <DataConnections />}
			</div>
		</div>
	);
};

const commentedOutSection = () => {
	return (
		<>
			{/* <div className="col-md-12 l-mt-md">*/}
			{/*    <div className="row">*/}
			{/*        <div className="col-12">*/}
			{/*            <h5 className="a-heading a-heading--heading-3">*/}
			{/*                Analytics*/}
			{/*            </h5>*/}
			{/*            <p className="a-muted-text">Key metrics that help you keep tabs on how Maestro is being used across your organization.</p>*/}
			{/*        </div>*/}
			{/*    </div>*/}
			{/*    <div className="row">*/}
			{/*        <div className="col-12">*/}
			{/*            <div className="o-block">*/}
			{/*                <div className="o-stat-row o-stat-row--left-aligned">*/}
			{/*                    <div className="o-stat-row__stat m-stat">*/}
			{/*                        <span className="m-stat__value">984</span>*/}
			{/*                        <span className="m-stat__label">Average Message/Day</span>*/}
			{/*                    </div>*/}
			{/*                    <div className="o-stat-row__stat m-stat">*/}
			{/*                        <span className="m-stat__value">$213.87</span>*/}
			{/*                        <span className="m-stat__label">Average Cost/Day</span>*/}
			{/*                    </div>*/}
			{/*                    <div className="o-stat-row__stat m-stat">*/}
			{/*                        <span className="m-stat__value">$2.76</span>*/}
			{/*                        <span className="m-stat__label">Average Daily Cost/User</span>*/}
			{/*                    </div>*/}
			{/*                </div>*/}
			{/*                <div className="o-stat-row o-stat-row--left-aligned l-mt-sm">*/}
			{/*                    <div className="o-stat-row__stat m-stat">*/}
			{/*                        <span className="m-stat__value">262</span>*/}
			{/*                        <span className="m-stat__label">Average Chats/Day</span>*/}
			{/*                    </div>*/}
			{/*                    <div className="o-stat-row__stat m-stat">*/}
			{/*                        <span className="m-stat__value">412MB</span>*/}
			{/*                        <span className="m-stat__label">Average Storage/Day</span>*/}
			{/*                    </div>*/}
			{/*                    <div className="o-stat-row__stat m-stat">*/}
			{/*                        <span className="m-stat__value">59</span>*/}
			{/*                        <span className="m-stat__label">Average Attached Files/Day</span>*/}
			{/*                    </div>*/}
			{/*                </div>*/}
			{/*            </div>*/}
			{/*        </div>*/}
			{/*    </div>*/}

			{/*    <div className="row l-mt-md">*/}
			{/*        <div className="col-12">*/}
			{/*            <h5 className="a-heading a-heading--heading-3">*/}
			{/*                Quotas*/}
			{/*            </h5>*/}
			{/*            <p className="a-muted-text">Choose from available CAI data sources to provide more context to the assistant.</p>*/}
			{/*        </div>*/}
			{/*    </div>*/}
			{/*    <div className="row">*/}
			{/*        <div className="col-12">*/}
			{/*            <div className="o-block">*/}
			{/*                <div className="row">*/}
			{/*                    <div className="col-md-6">*/}
			{/*                        <div className="m-form-group">*/}
			{/*                            <label htmlFor="" className="a-label a-label--required">Messages / Min</label>*/}
			{/*                            <input type="number" className="a-text-input" value="200" />*/}
			{/*                        </div>*/}
			{/*                    </div>*/}
			{/*                    <div className="col-md-6">*/}
			{/*                        <div className="m-form-group">*/}
			{/*                            <label htmlFor="" className="a-label a-label--required">Messages / Hr</label>*/}
			{/*                            <input type="number" className="a-text-input" value="10000" />*/}
			{/*                        </div>*/}
			{/*                    </div>*/}
			{/*                </div>*/}
			{/*                <div className="row">*/}
			{/*                    <div className="col-md-6">*/}
			{/*                        <div className="m-form-group">*/}
			{/*                            <label htmlFor="" className="a-label a-label--required">Messages / Day</label>*/}
			{/*                            <input type="number" className="a-text-input" value="100000" />*/}
			{/*                        </div>*/}
			{/*                    </div>*/}
			{/*                    <div className="col-md-6">*/}
			{/*                        <div className="m-form-group">*/}
			{/*                            <label htmlFor="" className="a-label a-label--required">Cost / Day</label>*/}
			{/*                            <input type="text" className="a-text-input" value="100" />*/}
			{/*                        </div>*/}
			{/*                    </div>*/}
			{/*                </div>*/}
			{/*            </div>*/}
			{/*        </div>*/}
			{/*    </div>*/}
			{/*    <div className="row l-mt-sm">*/}
			{/*        <div className="col-12">*/}
			{/*            <div className="m-button-row">*/}
			{/*                <button className="a-button">Save Changes</button>*/}
			{/*            </div>*/}
			{/*        </div>*/}
			{/*    </div>*/}
			{/*</div> */}
		</>
	)
}

export default SymphonyAdminSettings;